import * as React from 'react'
// import { Main } from '../../../Logic/Main'
import * as Body from './Body'
import { getLogo } from './Bet'
// import * as Lounge from './Lounge'
import Socket from '../../../Socket/socket-init'
import * as Assets from '../../../assets/Assets'
import * as Utils from '../../../Logic/Utils'
// import * as Utils from '../../../Logic/Utils'
// import * as Assets from '../../../assets/Assets'
import { Link } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import Loader from './Loader'

const teamShirts: any[] = [
    {teamName: 'Arsenal', src: 'arsenal.png', color: '#FFF'},
    {teamName: 'Chelsea', src: 'chelsea.png', color: '#FFF'},
    {teamName: 'Everton', src: 'everton.png', color: '#FFF'},
    {teamName: 'Fulham', src: 'tottenham.png', color: '#000'},
    {teamName: 'Liverpool', src: 'liverpool.png', color: '#FFF'},
    {teamName: 'Manchester City', src: 'manchester-city.png', color: '#000'},
    {teamName: 'Manchester United', src: 'manchester-united.png', color: '#FFF'},
    {teamName: 'Newcastle United', src: 'wba.png', color: '#000'},
    {teamName: 'Tottenham Hotspur', src: 'tottenham.png', color: '#000'},
    {teamName: 'West Ham United', src: 'west-ham.png', color: '#FFF'},
    {teamName: 'Burnley', src: 'burnley.png', color: '#FFF'},
    {teamName: 'Cardiff City', src: 'crystal-palace.png', color: '#FFF'},
    {teamName: 'Crystal Palace', src: 'crystal-palace.png', color: '#FFF'},
    {teamName: 'Leicester', src: 'leicester.png', color: '#FFF'},
    {teamName: 'Southampton', src: 'southampton.png', color: '#FFF'},
    {teamName: 'Watford', src: 'watford.png', color: '#000'},
    {teamName: 'Wolverhampton Wanderers', src: 'hull-city.png', color: '#000'},
    {teamName: 'Brighton & Hove Albion', src: 'everton.png', color: '#FFF'},
    {teamName: 'Huddersfield Town', src: 'everton.png', color: '#FFF'},
    {teamName: 'AFC Bournemouth', src: 'bournemouth.png', color: '#FFF'},
    {teamName: 'Leicester City', src: 'leicester.png', color: '#FFF'}
]

export function setPosition(position: string): string {
    switch (position) {
        case 'G':
            return 'Goalkeeper'
        case 'D':
            return 'Defender'
        case 'M':
            return 'Midfielder'
        default:
            return 'Attacker'
    }
}

export function getTeamShirt(team: string) {
    for (const shirt of teamShirts) {
        if (team === shirt.teamName) {
            return shirt
        }
    }
}

interface IState {
    userDropdown: boolean
    popupTeam: boolean
    popupPlayer: boolean
    team: any
    player: any
    injury: any
    mobileMenu: boolean
}

class Standings extends React.Component<{}, IState> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            popupTeam: false,
            popupPlayer: false,
            team: {},
            player: {},
            injury: {},
            mobileMenu: false
        }

        Socket.Send('get-leaderboard', {league: 'england'})
    }

    render() {
        if (Socket.Get<any>('get-leaderboard').loading !== 'loaded') {
            return <Loader/>
        } else {
            return (
                <section className="wrapper">
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button 
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button" 
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                        data-toggle="collapse" 
                                        data-target="#navbar-collapse-mid" 
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                        <span className="sr-only">Toggle navigation</span>
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>                                  
                                    <Link className="navbar-brand" to="/">
                                        <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link> 
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav 
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <main className="main">
                        <div className="standings">
                            <table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th className="standings-team-name">Team</th>
                                        <th>GP</th>
                                        <th className="mobile-hide">W</th>
                                        <th className="mobile-hide">D</th>
                                        <th className="mobile-hide">L</th>
                                        <th className="mobile-hide">GF</th>
                                        <th className="mobile-hide">GA</th>
                                        <th>GD</th>
                                        <th style={{ borderRight: '0' }}>PTS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.setStandings()}
                                </tbody>
                            </table>
                        </div>
                        {(this.state.popupTeam) ? this.showPopupTeam() : null}
                        {(this.state.popupPlayer) ? this.showPopupPlayer() : null}
                    </main>
                </section>
            )
        }
    }

    setStandings(): JSX.Element[] {
        const leaderboard = Socket.Get<any>('get-leaderboard').leaderboard[0]
        const standings: JSX.Element[] = []
        for (const team of leaderboard) {
            standings.push(
                <tr key={standings.length} style={{ background: (leaderboard.indexOf(team) % 2 !== 0) ? '#E7E7E7' : 'rgb(255, 255, 255)' }}>
                    <td style={{ borderLeft: '1px solid rgb(225, 225, 225)' }}>{team.position}</td>
                    <td>
                        <div style={{ width: '20%', textAlign: 'center' }}><img src={getLogo(team.name)} /></div>
                        <div style={{ width: '80%' }}>
                            <a
                                onClick={() => { this.setState({ popupTeam: true, team }), Socket.Send('get-team-info', { teamId: team.id }) }}
                            >
                                {team.name}
                            </a>
                        </div>
                    </td>
                    <td>{team.gamesPlayed}</td>
                    <td className="mobile-hide">{team.wins}</td>
                    <td className="mobile-hide">{team.draws}</td>
                    <td className="mobile-hide">{team.losses}</td>
                    <td className="mobile-hide">{team.goalsFor}</td>
                    <td className="mobile-hide">{team.goalsAgainst}</td>
                    <td>{team.goalsDifference}</td>
                    <td>{team.points}</td>
                </tr>
            )
        }
        return standings
    }

    showPopupTeam(): JSX.Element {
        const team = Socket.Get<any>('get-team-info')
        if (team.loading !== 'loaded') {
            return <Loader/>
        } else {
            const screenPosition = document.documentElement.scrollTop + 150
            const top = screenPosition.toString() + 'px'
            const selectedTeam = team.teamInfo
            return (
                <div className="popup">
                    <div className="popup-inner" style={{ bottom: '10%', overflow: 'scroll', top }}>
                        <div className="team-info">
                            <div>
                                <span style={{ width: '10%', marginRight: '10px' }}><img src={'data:image/png;base64,' + selectedTeam.logo} style={{ width: '60px', height: '60px' }} /></span>
                                <span className="team-info-name">{selectedTeam.name.toUpperCase()}</span>
                                <span className="team-info-close"><img src="cancel.svg" style={{ width: '30px', height: '30px' }} onClick={() => this.setState({ popupTeam: false })} /></span>
                            </div>
                            <div className="team-data">
                                <span>Country: <p>{selectedTeam.country}</p></span>
                                <span>Founded: <p>{selectedTeam.founded}</p></span>
                                <span>Coach: <p>{selectedTeam.coach}</p></span>
                            </div>
                            <div className="team-data-second">
                                <span>Stadium: <p>{selectedTeam.venueName}</p></span>
                                <span>Stadium capacity: <p>{selectedTeam.venueCapacity}</p></span>
                            </div>
                        </div>
                        <div className="team-players">
                            <p style={{ fontSize: '16px' }}><b>TEAM SQUAD</b></p>
                            <div className="team-table">
                                {this.setSquad(selectedTeam)}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    setSquad(team: any): JSX.Element[] {
        const players: JSX.Element[] = []
        const teamShirt = getTeamShirt(team.name)
        for (let i = 0; i < team.squad.length; i++) {
            const injured = this.checkInjury(team.squad[i].name, team.sidelined)
            if (i === 0 || (team.squad[i - 1] && team.squad[i - 1].position !== team.squad[i].position)) {
                players.push(
                    <p key={players.length} style={{ fontSize: '15px', marginBottom: '0' }}><b>{setPosition(team.squad[i].position) + 's'}</b></p>
                )
            }
            players.push(
                <div key={players.length} className="team-table-player">
                    <div className="team-table-player-shirt">
                        <img src={teamShirt.src}/>
                        <div 
                            className={(team.squad[i].number.toString().length === 1) ? 'text-on-image shirt-one-number' : 'text-on-image shirt-two-numbers'}
                            style={{ color: teamShirt.color }}
                        >
                        {team.squad[i].number}
                        </div>
                    </div>
                    <div style={{ width: '65%', marginLeft: '5%' }}>
                        <span 
                            onClick={() => {
                                this.setState({ popupPlayer: true, injury: injured, player: team.squad[i] }),
                                Socket.Send('get-player-info', {teamId: this.state.team.id, playerId: team.squad[i].id})  
                            }}
                        >
                        <a style={{ color: (injured) ? '#F03300' : 'rgb(41, 160, 0)'}}>{team.squad[i].name}</a>
                        </span>
                        <span>{'Age: ' + team.squad[i].age}</span>
                        <span>{'Appearances: ' + team.squad[i].appearences}</span>
                    </div>
                </div>
            )
        }
        return players
    }

    checkInjury(player: string, sidelined: any) {
        for (const item of sidelined) {
            if (item.name === player) return item
        }
    }

    showPopupPlayer(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 50
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="team-players">
                        <span className="team-players-name"><b>{this.state.player.name}</b></span>
                        <span className="team-info-close"><img src="cancel.svg" onClick={() => this.setState({ popupPlayer: false })} /></span>
                        <table className="team-table">
                            <thead>
                                <tr>
                                    <th className="player-stats-hide">Position</th>
                                    <th className="player-stats-hide">Age</th>
                                    <th className="player-stats-hide">Shirt number</th>
                                    <th>Appearances</th>
                                    <th>Starts</th>
                                    <th>Minutes</th>
                                    <th>Goals</th>
                                    <th>Assists</th>
                                    <th className="player-stats-hide">Yellow Cards</th>
                                    <th className="player-stats-hide">Red Cards</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="player-stats-hide">{setPosition(this.state.player.position)}</td>
                                    <td className="player-stats-hide">{this.state.player.age}</td>
                                    <td className="player-stats-hide">{this.state.player.number}</td>
                                    <td>{this.state.player.appearences}</td>
                                    <td>{this.state.player.lineups}</td>
                                    <td>{this.state.player.minutes}</td>
                                    <td>{this.state.player.goals}</td>
                                    <td>{this.state.player.assists}</td>
                                    <td className="player-stats-hide">{this.state.player.yellowCards}</td>
                                    <td className="player-stats-hide">{this.state.player.redcards + this.state.player.yellowRedCards}</td>
                                </tr>
                            </tbody>
                        </table>
                        {(this.state.injury) ?
                            <div>
                                <span style={{ marginTop: '20px', fontSize: '20px', color: '#F03300' }}><b>Injury stats</b></span>
                                <div className="injury-stats">
                                    <span><b>Injury: </b><i>{this.state.injury.description}</i></span>
                                    <span><b>Injured from: </b><i>{this.state.injury.startDate}</i></span>
                                    <span><b>Expected comeback: </b><i>{(this.state.injury.endDate !== '') ? this.state.injury.endDate : 'Unknown'}</i></span>
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(Standings)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Standings.tsx